import { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-serif text-3xl md:text-4xl font-semibold text-stone-900 mb-3">
            Terms of Service
          </h1>
          <p className="text-stone-500 text-sm font-sans mb-12">
            Last updated: May 31, 2026
          </p>

          <div className="flex flex-col gap-8 text-stone-700 font-sans text-sm leading-relaxed">
            <section>
              <h2 className="font-serif text-xl font-semibold text-stone-900 mb-3">
                1. General Provisions
              </h2>
              <p className="mb-3">
                These Terms of Service ("Terms") govern the use of the Lithos website and all related services. By accessing or using our website, you agree to be bound by these Terms. If you do not agree, please refrain from using our services.
              </p>
              <p>
                Lithos operates as a B2B importer and distributor of natural stone products. Our services are intended exclusively for business professionals, including architects, builders, contractors, and construction companies.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-semibold text-stone-900 mb-3">
                2. Use of Website
              </h2>
              <p className="mb-3">
                You agree to use our website only for lawful purposes and in a manner that does not infringe the rights of others or restrict their use and enjoyment of the site. Prohibited activities include, but are not limited to:
              </p>
              <ul className="list-disc list-inside flex flex-col gap-2 ml-2">
                <li>Using the website in any way that causes damage or impairment</li>
                <li>Attempting to gain unauthorized access to any part of the website</li>
                <li>Using automated systems to access the website without permission</li>
                <li>Reproducing, duplicating, or reselling any part of the website without consent</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-xl font-semibold text-stone-900 mb-3">
                3. Product Information and Quotations
              </h2>
              <p className="mb-3">
                All product images, descriptions, and specifications on our website are provided for informational purposes. Natural stone is a natural material, and variations in color, pattern, and texture are inherent characteristics that make each piece unique.
              </p>
              <p className="mb-3">
                Quotations provided through our website or by our sales team are valid for the specified period and subject to stock availability. Prices are quoted in Euros (EUR) unless otherwise stated and do not include applicable taxes, shipping, or customs duties unless explicitly specified.
              </p>
              <p>
                Final orders are subject to confirmation and acceptance by Lithos. We reserve the right to refuse or cancel any order at our discretion.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-semibold text-stone-900 mb-3">
                4. Intellectual Property
              </h2>
              <p>
                All content on this website, including text, images, graphics, logos, and product photography, is the intellectual property of Lithos or its licensors and is protected by copyright and trademark laws. You may not reproduce, distribute, or create derivative works from any content without prior written consent.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-semibold text-stone-900 mb-3">
                5. Limitation of Liability
              </h2>
              <p className="mb-3">
                Lithos strives to ensure the accuracy of all information on this website. However, we do not warrant that the content is complete, accurate, or current at all times. We shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the website or reliance on any information provided.
              </p>
              <p>
                This limitation of liability applies to the fullest extent permitted by applicable law.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-semibold text-stone-900 mb-3">
                6. Governing Law
              </h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of France. Any disputes arising from these Terms or your use of the website shall be subject to the exclusive jurisdiction of the courts of France.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-semibold text-stone-900 mb-3">
                7. Changes to Terms
              </h2>
              <p>
                Lithos reserves the right to modify these Terms at any time. Changes will be effective immediately upon posting on the website. Your continued use of the website after any changes constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-semibold text-stone-900 mb-3">
                8. Contact
              </h2>
              <p>
                For questions about these Terms of Service, please contact us at{" "}
                <a href="mailto:contact@lithos.pro" className="text-gold-600 hover:underline">
                  contact@lithos.pro
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}